import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
// @ts-expect-error untyped dependency
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { getThemesStorefrontRoute } from '../../utils/urls';
import { resultCardStyles } from '../../storefront/utils/resultCardStyles';
import { selectCollectionsRequestState, selectDisplayedCollections } from '../../slices/collections/collectionsSlice';
import CollectionCard from './ThemeCollectionCard';
const MAX_COLLECTIONS_PER_PAGE = 24;
const StyledCollectionCard = styled(CollectionCard).withConfig({
  displayName: "ThemeCollectionsSection__StyledCollectionCard",
  componentId: "tu8noz-0"
})(["", ""], resultCardStyles);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ThemeCollectionsSection__StyledRouterLink",
  componentId: "tu8noz-1"
})(["display:flex;align-items:stretch;"]);
export default function ThemeCollectionsSection({
  trackInteraction
}) {
  const collections = useSelector(selectDisplayedCollections);
  const collectionsRequestState = useSelector(selectCollectionsRequestState);
  const [page, setPage] = useState(1);
  const displayedCollections = useMemo(() => collections.filter(collection => !!collection.publishedListing), [collections]);
  const offset = useMemo(() => (page - 1) * MAX_COLLECTIONS_PER_PAGE, [page]);
  const limit = useMemo(() => displayedCollections.length && displayedCollections.length <= MAX_COLLECTIONS_PER_PAGE * page ? displayedCollections.length : offset + MAX_COLLECTIONS_PER_PAGE, [displayedCollections, offset, page]);
  const currentCollections = useMemo(() => {
    return displayedCollections.slice(offset, limit);
  }, [displayedCollections, offset, limit]);
  const pageCount = Math.ceil(displayedCollections.length / MAX_COLLECTIONS_PER_PAGE);
  const needsPagination = pageCount > 1;
  const handlePageChange = useCallback(newPage => {
    setPage(newPage);
    trackInteraction('change collections page', {
      page: newPage
    });
  }, [trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingWrapper, {
      requestStatus: collectionsRequestState,
      children: /*#__PURE__*/_jsx(UICardGrid, {
        className: "p-bottom-10 p-x-5 m-x-15",
        children: currentCollections.map(collection => collection.publishedListing && /*#__PURE__*/_jsx(StyledRouterLink, {
          to: getThemesStorefrontRoute(collection.publishedListing.slug),
          use: "unstyled",
          children: /*#__PURE__*/_jsx(StyledCollectionCard, {
            collection: collection
          })
        }, `collection-${collection.id}`))
      })
    }), needsPagination && /*#__PURE__*/_jsx(UIPaginator, {
      onPageChange: ({
        target: {
          value
        }
      }) => handlePageChange(value),
      pageCount: pageCount
    })]
  });
}